// extracted by mini-css-extract-plugin
module.exports = {"MainSpinnerContainer":"Main_MainSpinnerContainer__1DDec"};